import * as React from 'react';
import axios from 'axios';
import { BuildJsonType, EnhancedAppointment } from '@bb/domain/dist/types';

import errorReporter from '@app/errorReporter';
import { Loading } from '../../react-common';

import AppointmentPropertyUpdate, {
  NotificationOptions,
} from '../../DashboardComponents/AppointmentPropertyUpdate';

type AppointmentPropertyUpdatePageProps = {
  appointment: BuildJsonType<EnhancedAppointment>;
  ToastService: {
    add: (...args: any[]) => void;
  };
};

type AppointmentPropertyUpdatePageState = {
  isLoading: boolean;
  notificationOptions: NotificationOptions;
};

class AppointmentPropertyUpdatePage extends React.Component<
  AppointmentPropertyUpdatePageProps,
  AppointmentPropertyUpdatePageState
> {
  constructor(props: AppointmentPropertyUpdatePageProps) {
    super(props);
    this.state = {
      isLoading: true,
      notificationOptions: null,
    };
  }

  async componentDidMount() {
    const { appointment } = this.props;
    try {
      const { data: newOptions } = await axios.get<NotificationOptions>(
        `/user/current/listing_notification_setting/${appointment.listingId}`,
      );
      this.setState({
        notificationOptions: newOptions,
      });
    } catch (err) {
      errorReporter.error(err);
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  }

  saveNotificationOptions = async () => {
    const { appointment, ToastService } = this.props;
    const { notificationOptions } = this.state;

    this.setState({
      isLoading: true,
    });

    try {
      const { data: updatedOptions } = await axios.post<NotificationOptions>(
        `/user/current/listing_notification_setting/${appointment.listingId}`,
        notificationOptions,
      );
      this.setState(
        {
          isLoading: false,
          notificationOptions: updatedOptions,
        },
        () => {
          ToastService.add({
            message:
              'Notification preferences on the listing have been updated successfully',
            type: 'success',
          });
        },
      );
    } catch (err) {
      errorReporter.error(err);
      this.setState(
        {
          isLoading: false,
        },
        () => {
          ToastService.add({
            message: 'Failed to update notification preferences on the listing',
            type: 'danger',
          });
        },
      );
    }
  };

  onNotificationOptionsChange = (options: Partial<NotificationOptions>) => {
    const { isLoading, notificationOptions } = this.state;
    const newOptions = {
      ...notificationOptions,
      ...options,
    };

    this.setState({
      notificationOptions: newOptions,
    });
  };

  public render() {
    const { appointment } = this.props;
    const { isLoading, notificationOptions } = this.state;

    if (isLoading) return <Loading size="fa-5x" />;

    return (
      <>
        <div style={{ display: 'flex' }}>
          <h2 className="font-light m-b-xs">{`${appointment.listing.line1} ${
            appointment.listing.line2 || ''
          } - Property Updates`}</h2>
        </div>
        <hr style={{ marginTop: '10px', marginBottom: '10px' }} />
        <AppointmentPropertyUpdate
          isLoading={isLoading}
          newNotifications={notificationOptions}
          listingAddress={`${appointment.listing.line1} ${
            appointment.listing.line2 || ''
          }`}
          onNotificationOptionsChange={this.onNotificationOptionsChange}
          saveNotifications={this.saveNotificationOptions}
        />
      </>
    );
  }
}

export default AppointmentPropertyUpdatePage;
